<template>
  <div class="home">
    <!-- Navbar -->
    <!-- <navbar></navbar> -->
    <cq-master>


      <!-- Carousel -->
      <cq-carousel></cq-carousel>


      <!-- Introduction -->
      <cq-intro> </cq-intro>


      <!-- The Gain Livinar -->
      <cq-tgl></cq-tgl>


      <!-- No Gyaan only Gain -->
      <cq-ngog></cq-ngog>


      <!-- Proof Points -->
      <div class="testimonal">
        <cq-header headertext="PROOF POINTS"></cq-header>
        <cq-testimonials
          :testimonials="testimonials"
        > </cq-testimonials>
      </div>


      <!-- Welcome to Colloquium -->
      <cq-wtc></cq-wtc>


      <!-- MDH -->
      <cq-mdh></cq-mdh>    


      <!-- MV - Gain Guru -->
      <cq-gg></cq-gg>
      
    </cq-master>

    <!-- Upward Arrow -->
    <!-- <cq-uparrow></cq-uparrow>  -->


    <!-- Footer -->
    <!-- <cq-footer></cq-footer>   -->
  </div>
</template>

<script>
import CQMaster from '../components/layout/CQMaster.vue'
import nimesh from '../assets/image/home/nimesh.png'
// import Navbar from '../components/layout/Navbar.vue'
import CQHeader from '../components/ui/CQHeader.vue'
import CQCarousel from '../components/ui/CQCarousel.vue'
import CQIntroduction from '../components/ui/CQIntroduction.vue'
import CQTGL from '../components/ui/CQTheGainLivinar.vue'
import CQNGOG from '../components/ui/CQNoGyaan.vue'
import CQTestimonials from '../components/ui/CQTestimonails.vue'
import CQWTC from '../components/ui/CQWelcomeTC.vue'
import CQMDH from '../components/ui/CQMillionDollarHabbits.vue'
import CQGG from '../components/ui/CQGainGuru.vue'
// import CQMasterVue from '../components/layout/CQMaster.vue'
// import CQUpArrow from '../components/ui/CQUpArrow.vue'
// import CQFooter from '../components/layout/CQFooter.vue'

export default {
  name: 'home',
  components: {
    'cq-master' : CQMaster,
    // 'navbar' : Navbar,
    'cq-carousel' : CQCarousel,
    'cq-intro' : CQIntroduction,
    'cq-tgl' : CQTGL,
    'cq-ngog' : CQNGOG,
    'cq-testimonials' : CQTestimonials,
    'cq-wtc' : CQWTC,
    'cq-mdh' : CQMDH,
    'cq-gg' : CQGG,
    // 'cq-uparrow' : CQUpArrow,
    // 'cq-footer' : CQFooter,
    'cq-header': CQHeader
  },
  data() {
    return {
      testimonials: [
        {
            imageLink: nimesh ,
            name: 'Nimesh Mehta', 
            designation: 'Director & Head - Sales & Products ASK Investment Managers Limited.',
            messages: [
                'At the end of the Colloquium I did 342 Crores even though historically, the Company has never crossed 258 Croses in a year in any financial year since its inception.', 
                'After 2 quarters of the Colloquium, in the last quarter I clocked 550 Crores. Life is not the same.',
                'After 4 quarters of the Colloquium, we are hitting 200 Crores a month which 2 years ago was my annual target.',
                'I had never imagined this kind of growth in my life.'
            ]
        },
        {
            imageLink: nimesh ,
            name: 'Nimesh Mehta', 
            designation: 'Director & Head - Sales & Products ASK Investment Managers Limited.',
            messages: [
                'At the end of the Colloquium I did 342 Crores even though historically, the Company has never crossed 258 Croses in a year in any financial year since its inception.', 
                'After 2 quarters of the Colloquium, in the last quarter I clocked 550 Crores. Life is not the same.',
                'After 4 quarters of the Colloquium, we are hitting 200 Crores a month which 2 years ago was my annual target.',
                'I had never imagined this kind of growth in my life.'
            ]
        }
      ]
    }
  }
}
</script>

<style>
h2,h3,h4,h5{
  color: #414042;
}

h3{
  font-size: 35px !important;
}

/* Mobile View */
@media only screen and (max-width: 992px){
  h2,h3,h4,h5{
    padding: 0 20px;
  }

  h2{
    font-size: 25px !important;
    }

  h3{
    font-size: 22px !important;
  }

  h4{
    font-size: 24px !important;
  }

}
/* End Mobile View */
</style>